<template>
    <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="type"
        prepend-inner-icon="mdi-calendar"
        readonly
        v-on="on"
        first-day-of-week="1"
        outlined
        color="secondary"
        height="52"
        class="mr-1"
        :rules="[v => !!v || 'Item is required']"
        @focus="getDate"
        id="hotel-date-activator"
      >
      </v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      @input="menu = false"
      color="secondary"
      :min="minDate"
      :show-current="minDate"
      no-title
      :disabled="$store.state.hotelSearch.checkInDate === null && type === 'Check out'"
      :rules="[v => !!v || 'Date is required']"
      >
    </v-date-picker>
    <p v-if="$store.state.hotelSearch.checkInDate === null && type === 'Check out'" class="red--text">Please enter the chek-in date first</p>
  </v-menu>
</template>

<script>
export default {
  props: ['type'],
  data () {
    return {
      date: '',
      menu: false
    }
  },
  computed: {
    dateFormatted () {
      return this.formatDate(this.date)
    },
    minDate () {
      if (this.type === 'Check in') {
        const today = new Date()
        // const tomorrow = new Date(today)
        today.setDate(today.getDate() + 1)
        const tomorrow = today.toISOString().substr(0, 10)
        return tomorrow
      } else {
        const checkIn = new Date(this.$store.state.hotelSearch.checkInDate).toISOString().substr(0, 10)
        const tomorrow = new Date(checkIn)
        tomorrow.setDate(tomorrow.getDate())
        return tomorrow.toISOString().slice(0, 10)
      }
    }
  },
  watch: {
    date (val) {
      this.type === 'Check in' ? this.$store.dispatch('setHotelCheckInDate', val) : this.$store.dispatch('setHotelCheckOutDate', val)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${day} ${months[month - 1]} ${year}`
    },
    getDate () {
      if (this.type === 'Check in') {
        this.$store.state.hotelSearch.checkInDate === null ? this.date = this.minDate : this.date = this.$store.state.hotelSearch.checkInDate
      } else {
        this.$store.state.hotelSearch.checkInDate === null ? this.date = '' : this.date = this.minDate
      }
    }
  },
  created () {
    if (this.type === 'Check in') {
      if (this.$store.state.hotelSearch.checkInDate !== null) this.date = this.$store.state.hotelSearch.checkInDate
      else this.date = ''
    } else {
      if (this.$store.state.hotelSearch.checkOutDate !== null) this.date = this.$store.state.hotelSearch.checkOutDate
      else this.date = ''
    }
  }
}
</script>
